import React from 'react';
import {
  Container,
  Row,
  Col,
  SearchInput,
  RadioGroup,
  IconButton,
  CirclePlusIcon,
  CustomSelect,
  SearchIcon
} from 'shared-portal-component';
import '@/components/organism/Users/UsersHeader/UsersHeader.scss';

import type { RadioOption, SelectOption } from '@/types/users.types';

type Scope = 'all' | 'internal' | 'external';

interface UsersHeaderProps {
  // search
  searchPlaceholder?: string;
  searchValue?: string;
  onSearchChange?: (v: string) => void;
  onSearch?: () => void;
  scope: Scope;
  onScopeChange: (v: Scope) => void;

  deptOptions?: string[];
  statusOptions?: string[];
  deptValues?: string[];
  statusValues?: string[];
  onDeptChange?: (v: string[]) => void;
  onStatusChange?: (v: string[]) => void;

  onCreate: () => void;
}

const scopeOptions: RadioOption[] = [
  { value: 'all',      label: 'All' },
  { value: 'internal', label: 'Internal' },
  { value: 'external', label: 'External' },
];

const UsersHeader: React.FC<UsersHeaderProps> = ({
  searchPlaceholder = 'Search Users...',
  searchValue,
  onSearchChange,
  onSearch,
  scope,
  onScopeChange,
  deptOptions = ['Dept / Org'],
  statusOptions = ['Status'],
  deptValues = [],
  statusValues = [],
  onDeptChange,
  onStatusChange,
  onCreate,
}) => {
    const handleDeptChange   = (next: string[]) => { onDeptChange?.(next); };
  const handleStatusChange = (next: string[]) => { onStatusChange?.(next); };

  const deptItems: SelectOption[] = (deptOptions)
    .filter(o => o !== 'Dept / Org')
    .map(o => ({ label: o, value: o }));

  const statusItems: SelectOption[] = (statusOptions)
    .filter(o => o !== 'Status')
    .map(o => ({ label: o, value: o }));

  return (
    <Container fluid className="users-header">
      <Row spacing="md" align="start" justify="start">
        <Col className="users-header__left" size="content">
          <Row spacing="none" align="center" wrap="wrap" className="users-header__row">
            <Col size="content">
              <SearchInput
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={(e: { target: { value: string; }; }) => { onSearchChange?.(e.target.value); }}
                onSearch={onSearch}
                leftIcon={<SearchIcon size="1x" />}
                 variant="outline"
                 showRightIcon={false}
              />
            </Col>
          </Row>

          <Row spacing="none" className="mt-4 users-header__filters" align="center">
            <Col size="content">
              <CustomSelect
                placeholder="Dept / Org"
                options={deptItems}
                value={deptValues}
                onChange={handleDeptChange}
                onAddNew={() => { /* open “Create Dept/Org” modal */ }}
                className="mr-4"
                addNewText="Add New Dept/Org"
              />
            </Col>

            <Col size="content">
              <CustomSelect
                placeholder="Status"
                options={statusItems}
                value={statusValues}
                onChange={handleStatusChange}
              />
            </Col>
          </Row>
        </Col>

        {/* Middle: radio chips */}
        <Col size="content" className="users-header__chips">
          <RadioGroup
            name="user-scope"
            value={scope}
            onChange={(value: string) => {
              if (value === 'all' || value === 'internal' || value === 'external') {
                onScopeChange(value);
              }
            }}
            options={scopeOptions}
            size="sm"
          />
        </Col>

        {/* Right: + button */}
        <Col>
        <Row spacing="none" justify="end">
          <IconButton
            ariaLabel="Create user"
            variant="secondary"
            size="md"
            icon={<CirclePlusIcon size="2x" />}
            onClick={onCreate}
          />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default UsersHeader;
